import styles from './index.module.scss';
const { main, embed, content } = styles;
export { main, embed, content };
